export default __webpack_public_path__ + "static/d-feature-6-01edcc0c285aaf07edd0f4fa6bb3b312.png";